import { render, staticRenderFns } from "./ConstructionConnection.vue?vue&type=template&id=5989371c"
import script from "./ConstructionConnection.vue?vue&type=script&lang=ts"
export * from "./ConstructionConnection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports